"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get buildDomainUrl () {
        return buildDomainUrl;
    },
    get buildUrl () {
        return buildUrl;
    }
});
const _domain = _export_star(require("./domain"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
const LOCAL_HOST = "localhost:8888";
const buildDomainUrl = (options = {})=>{
    const { environmentStage, subdomain, useDevEnvNames = true } = options;
    const domainConfig = (0, _domain.resolveDomainConfig)(environmentStage, {
        useDevEnvNames
    });
    if (!domainConfig) {
        return LOCAL_HOST;
    }
    return (0, _domain.buildDomain)(domainConfig, subdomain);
};
const buildUrl = (options = {})=>{
    const { environmentStage, subdomain, path, protocol } = options;
    // Determine the protocol - use http for local environments unless explicitly overridden
    const finalProtocol = protocol || (environmentStage === "local" || environmentStage === "localhost" ? "http" : "https");
    const domain = buildDomainUrl({
        environmentStage,
        subdomain
    });
    const basePath = path || "";
    return `${finalProtocol}://${domain}${basePath}`;
};
